export enum VoucherStatus {
  PENDING_APPROVAL = 'Pending Approval',
  APPROVED = 'Approved',
  REJECTED = 'Rejected',
  PAYMENT_PROGRESS = 'Payment Progress',
  PAYMENT_COMPLETED = 'Payment Completed',
}
